import { render } from "./MinhasIndicacoes.vue?vue&type=template&id=1e90a272"
import script from "./MinhasIndicacoes.vue?vue&type=script&lang=js"
export * from "./MinhasIndicacoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__